import { CanActivate, ExecutionContext, Injectable, UnauthorizedException } from '@nestjs/common';
import { Request } from 'express';
import { timingSafeEqual } from 'crypto';

// Protects the applications/API-key management endpoints — these are
// privileged operations the platform operator performs (register a new
// consuming product, issue its key), not something any consuming product
// itself ever calls. A shared secret is enough for a single-operator v1.
@Injectable()
export class AdminSecretGuard implements CanActivate {
  canActivate(context: ExecutionContext): boolean {
    const request = context.switchToHttp().getRequest<Request>();
    const provided = request.headers['x-admin-secret'];
    const expected = process.env.ADMIN_API_SECRET;

    if (
      typeof provided !== 'string' ||
      !expected ||
      provided.length !== expected.length ||
      !timingSafeEqual(Buffer.from(provided), Buffer.from(expected))
    ) {
      throw new UnauthorizedException('Invalid admin secret');
    }

    return true;
  }
}
